import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Languages, useAppContext, useLocale } from 'scbk-services';
import { HeaderStyles, LineIcon, Switch, SwitchWidthLabel, cn } from 'scbk-ui-web';

interface SubHeaderProps {
  onHistoryClick?: () => void;
  isScrolled?: boolean;
  className?: string;
  darkMode?: boolean;
  topBar?: boolean;
  onToggleLargeText?: (mode: 'Y' | 'N') => void;
  title?: string | React.ReactNode;
  onHandleAlert?: () => void;
  onHandleSearchPanel?: () => void;
  onHandleLogout?: () => void;
  openUserInfoPopup?: () => void;
}

const ComfyBankingHeader = ({
  title,
  isScrolled = false,
  darkMode = false,
  topBar = true,
  onToggleLargeText,
  onHandleAlert,
  onHandleSearchPanel,
  onHandleLogout,
  openUserInfoPopup,
}: SubHeaderProps) => {
  console.log('### comfy darkMode : ', darkMode);

  // 다국어처리
  const { t } = useTranslation();
  const { getLocale } = useLocale();
  // 현재 편한뱅킹 모드
  const { seniorMode: currentSeniorMode } = useAppContext();
  /**
   * 큰 글씨 여부
   */
  const isLargeText = currentSeniorMode === 'Y';

  const locale = useMemo(() => {
    return getLocale();
  }, [getLocale]);

  return (
    <div
      className={cn(HeaderStyles['comfy-header-fixed'], isScrolled ? HeaderStyles.scrolled : '')}
    >
      <header className={cn(HeaderStyles['comfy-header-wrap'], darkMode ? 'darkMode' : '')}>
        {topBar ? (
          <>
            {/* 국문 편한뱅킹인 경우에만 편한뱅킹 버튼 노출 */}
            {locale === Languages.KO && (
              <SwitchWidthLabel>
                <Switch
                  id="large-text-mode"
                  checked={isLargeText}
                  onCheckedChange={() => {
                    onToggleLargeText && onToggleLargeText('N');
                  }}
                  data-cn="홈 Header"
                  data-ac={isLargeText ? '일반뱅킹 전환' : '편한뱅킹 전환'}
                  data-tx={isLargeText ? '일반뱅킹 사용하기' : '편한뱅킹 사용하기'}
                >
                  <label>편한</label>
                </Switch>
              </SwitchWidthLabel>
            )}
            <button
              className={cn(HeaderStyles['comfy-header-menu'], 'com-box-shadow')}
              aria-label={t('Layout.ComfyBankingHeader.001', { defaultValue: '로그아웃' })}
              onClick={(e) => {
                e.preventDefault();

                onHandleLogout && onHandleLogout();
              }}
            >
              {t('Layout.ComfyBankingHeader.002', { defaultValue: '로그아웃' })}
            </button>
          </>
        ) : (
          <>
            <h1
              className="heading-h4 font-weight-bold text-basic-01 text-center !leading-10 w-full"
              onClick={(e) => {
                e.preventDefault();
                openUserInfoPopup?.();
              }}
            >
              {title}
            </h1>
            <div className="absolute top-4 right-5">
              <div className={HeaderStyles['sub-header-info']}>
                <button
                  aria-label={t('Layout.ComfyBankingHeader.003', { defaultValue: '알림' })}
                  onClick={(e) => {
                    e.preventDefault();
                    onHandleAlert && onHandleAlert();
                  }}
                >
                  <LineIcon icoColor="bg-icon-basic-01" icoName="ico-alert" />
                </button>
                <button
                  aria-label={t('Layout.ComfyBankingHeader.004', { defaultValue: '검색' })}
                  onClick={(e) => {
                    e.preventDefault();
                    onHandleSearchPanel && onHandleSearchPanel();
                  }}
                >
                  <LineIcon icoColor="bg-icon-basic-01" icoName="ico-search" />
                </button>
              </div>
            </div>
          </>
        )}
      </header>
    </div>
  );
};

export { ComfyBankingHeader };
